export interface CustomSideDrawerProps {
  content: HTMLElement
}

const CustomSideDrawer = ({ content }: CustomSideDrawerProps): JSX.Element => (
  <div
    style={{
      height: 'calc(100vh - 125px)',
      overflow: 'auto',
      paddingBottom: 'var(--goto-spacing-02)',
      paddingLeft: 'var(--goto-spacing-04)',
      paddingRight: 'var(--goto-spacing-04)',
    }}
    ref={(el) => {
      if (el && el.firstChild !== content) {
        el.innerHTML = ''
        el.appendChild(content)
      }
    }}
  />
)

export default CustomSideDrawer
